import React, { useState, useEffect, useContext } from 'react'
import styles from './PagoRecurrente.module.css'
import PagoCard from './PagoCard'
import Subtitle from '../../components/Subtitle'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'
import SubMenu from '../../components/SubMenu/SubMenu'

import forge from 'node-forge'

//Utiles
import * as Constantes from '../../utils/constantes'
import * as Funciones from '../../utils/funciones'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'
import * as ProductoRepository from "../../services/repositories/producto-repository";
import * as PagoRecurrenteRepository from "../../services/repositories/pago-recurrente-repository";
import * as RequisitoRepository from "../../services/repositories/requisito-repository"

const PagoRecurrente = ({ history }) => {
  const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
  let user = generalState.users.filter(user => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  const initialState = {
    estaCargando: true,
    errorCargando: null,
    productos: null,
    productosMostrar: null,
    recurrente: null,
    pago: [
      //dolares
      {
        codigoTipoCobranza: 3,
        codigoOperadorTarjeta: 0,
        codigoTipoCuenta: 0,
        numeroTarjeta: null,
        fechaVencimiento: ''
      },
      //soles
      {
        codigoTipoCobranza: 3,
        codigoOperadorTarjeta: 0,
        codigoTipoCuenta: 0,
        numeroTarjeta: null,
        fechaVencimiento: ''
      }
    ],
    reloadValidacion: false,
    codMonedaError: null,
    campoValidado: [
      {
        medioPago: true,
        //Cargo Cuenta Bancaria
        bancoEntidad: true,
        tipoCuenta: true,
        numeroCuenta: true,
        //Tarjeta de Credito/Debito
        operadorTarjeta: true,
        numeroTarjeta: true,
        fechaVencimiento: true
      },
      {
        medioPago: true,
        //Cargo Cuenta Bancaria
        bancoEntidad: true,
        tipoCuenta: true,
        numeroCuenta: true,
        //Tarjeta de Credito/Debito
        operadorTarjeta: true,
        numeroTarjeta: true,
        fechaVencimiento: true
      }
    ],
    mensajes: [
      {
        cobranza: '',
        //Cargo Cuenta Bancaria
        tipoBanco: '',
        tipoCuenta: '',
        numeroCuenta: '',
        //Tarjeta Credito/Debito
        tipoTarjeta: '',
        numeroTarjeta: '',
        vencimiento: ''
      },
      {
        cobranza: '',
        //Cargo Cuenta Bancaria
        tipoBanco: '',
        tipoCuenta: '',
        numeroCuenta: '',
        //Tarjeta Credito/Debito
        tipoTarjeta: '',
        numeroTarjeta: '',
        vencimiento: ''
      }
    ],
    check: false,
    numerosCuenta: [
      {
        ini: null,
        nuevo: null
      },
      {
        ini: null,
        nuevo: null
      }
    ],
    cuentaInicial: null,
    pasarVal: true
  }

  const [state, setState] = useState(initialState)
  const [bloqueaData, setBloqueaData] = useState(false)

  const cargarDatosIniciales = async () => {
    const obtenerProductos = async () => {
      const response = await ProductoRepository.listarProductos(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        let dolares = {
          moneda: '',
          frecuenciaPago: '',
          primaTotal: 0
        }
        let soles = {
          moneda: '',
          frecuenciaPago: '',
          primaTotal: 0
        }
  
        let products = []
  
        let suma = (valor, nextItem) => valor + nextItem.primaTotal
        let dolar = response.productos.filter(pro => pro.simboloMoneda === '$')
        if (dolar.length > 0) {
          dolares.moneda = dolar.map(mon => mon.moneda)[0]
          dolares.frecuenciaPago = dolar.map(fre => fre.frecuenciaPago.descripcion)[0]
          dolares.primaTotal = dolar.reduce(suma, 0)
        }
  
        let sol = response.productos.filter(pro => pro.simboloMoneda === 'S/')
        if (sol.length > 0) {
          soles.moneda = sol.map(mon => mon.moneda)[0]
          soles.frecuenciaPago = sol.map(fre => fre.frecuenciaPago.descripcion)[0]
          soles.primaTotal = sol.reduce(suma, 0)
        }
  
        if (dolar.length > 0 && sol.length > 0) {
          products.push(dolares)
          products.push(soles)
        } else if (dolar.length > 0) {
          products.push(dolares)
        } else if (sol.length > 0) {
          products.push(soles)
        }
  
        setState((state) => {
          return {
            ...state,
            productos: response.productos,
            productosMostrar: products
          }
        })
  
        await obtenerPagoRecurrente()
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }
  
    const obtenerPagoRecurrente = async () => {
      const response = await PagoRecurrenteRepository.obtenerPagoRecurrente(cotizacion.idSolicitudMultiple)
      if(response.error === null) {
        let productPe = 1
        let sol = cotizacion.productos.filter(s => s.moneda.codigo === 2)
        let dolar = cotizacion.productos.filter(s => s.moneda.codigo === 1)
  
        if (dolar.length > 0 && sol.length > 0) {
          productPe = 2
        } else if (dolar.length > 0) {
          productPe = 1
        } else if (sol.length > 0) {
          productPe = 1
        }
  
        let newPago = []
        //CMUNAYLLA: se cambia la logica de validacion. Ahora se considera 'codigoOperadorTarjeta' para las comparaciones
        //validaciones para mostrar la data que viene del servicio
        if (response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta === null && response.pagoRecurrente.pagoRecurrente[0].codigoTipoCobranza !== 4) {
          newPago = null
        } else {
          setBloqueaData(true)
          if (response.pagoRecurrente.pagoRecurrente.length === 1) {
            newPago = response.pagoRecurrente.pagoRecurrente
          } else if (response.pagoRecurrente.pagoRecurrente.length === 2) {
            if (productPe === 2 && (response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta === response.pagoRecurrente.pagoRecurrente[1].codigoOperadorTarjeta)) {
              newPago = response.pagoRecurrente.pagoRecurrente
            } else if (productPe === 2 && (response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta !== response.pagoRecurrente.pagoRecurrente[1].codigoOperadorTarjeta)) {
              newPago = response.pagoRecurrente.pagoRecurrente
            } else if (productPe === 1) {
              newPago.push(response.pagoRecurrente.pagoRecurrente[0])
            }
          } else if (response.pagoRecurrente.pagoRecurrente.length === 3) {
            if (productPe === 2 && (response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta === response.pagoRecurrente.pagoRecurrente[1].codigoOperadorTarjeta ===
              response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta === response.pagoRecurrente.pagoRecurrente[2].codigoOperadorTarjeta)) {
              newPago.push(response.pagoRecurrente.pagoRecurrente[0])
              newPago.push(response.pagoRecurrente.pagoRecurrente[1])
            } else if (productPe === 2 && (response.pagoRecurrente.pagoRecurrente[0].codigoOperadorTarjeta === response.pagoRecurrente.pagoRecurrente[1].codigoOperadorTarjeta)) {
              newPago.push(response.pagoRecurrente.pagoRecurrente[0])
              newPago.push(response.pagoRecurrente.pagoRecurrente[2])
            } else if (productPe === 2 && (response.pagoRecurrente.pagoRecurrente[1].codigoOperadorTarjeta === response.pagoRecurrente.pagoRecurrente[2].codigoOperadorTarjeta)) {
              newPago.push(response.pagoRecurrente.pagoRecurrente[0])
              newPago.push(response.pagoRecurrente.pagoRecurrente[1])
            } else if (productPe === 1) {
              newPago.push(response.pagoRecurrente.pagoRecurrente[0])
            }
          }
        }
  
        setState((state) => {
          return {
            ...state,
            recurrente: newPago,
            pagoService: response.pagoRecurrente.pagoRecurrente,
            check: response.pagoRecurrente.usarMismoMedioPago === null ? false : response.pagoRecurrente.usarMismoMedioPago
          }
        })
      } else {
        generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
      }
    }

    generalDispatch(GeneralActions.updateEstadoCargando(true))
    setState((state) => {
      return {
        ...state,
        codMonedaError: null
      }
    })
    await obtenerProductos()
    generalDispatch(GeneralActions.updateEstadoCargando(false))
  }

  useEffect(() => {
    cargarDatosIniciales()
  }, [])

  // Funcion para encriptar numero de tarjeta
  const encriptamiento = (numero) => {
    const key = process.env.REACT_APP_PUBLIC_KEY_ENCRYPT
    const pem = key
    const publicKey = forge.pki.publicKeyFromPem(pem)

    const buffer = forge.util.createBuffer(numero, 'utf8')
    const bytes = buffer.getBytes()

    const encryptionScheme = 'RSAES-PKCS1-V1_5'
    const encrypted = publicKey.encrypt(bytes, encryptionScheme)
    const b64Encoded = forge.util.encode64(encrypted)

    return b64Encoded
  }

  const validarDatosIguales = async () => {
    //Validar Datos Repetidos
    if(state.pago.length > 1 &&
      state.pago[0].codigoOperadorTarjeta === state.pago[1].codigoOperadorTarjeta &&
      state.pago[0].codigoTipoCobranza === state.pago[1].codigoTipoCobranza &&
      state.pago[0].codigoTipoCuenta === state.pago[1].codigoTipoCuenta &&
      state.pago[0].fechaVencimiento === state.pago[1].fechaVencimiento &&
      state.pago[0].numeroTarjeta === state.pago[1].numeroTarjeta) {
        generalDispatch(GeneralActions.updateError({ mensajeRespuesta: 'Los datos de los pagos recurrentes coinciden.' },
          '¡Alerta!', false, 'Confirmar', () => validarTipoCuenta(true), 'Cancelar', () => limpiarCamposPago(1)))
        return false
    } else {
      let salida = await validarTipoCuenta(false)
      return salida
    }
  }

  const limpiarCamposPago = (indice) => {
    let pagos = state.pago.map((pago, index) => {
      if(index === indice) {
        pago.codigoTipoCobranza = 0
        pago.codigoOperadorTarjeta = 0
        pago.codigoTipoCuenta = 0
        pago.numeroTarjeta = null
      }
      return pago
    })
    setState((state) => {
      return {
        ...state,
        pago: pagos
      }
    })
  }

  const validarTipoCuenta = async (flagPagoRepetido) => {
    let check = state.check
    if(flagPagoRepetido !== null && flagPagoRepetido === true) {
      limpiarCamposPago(1)
      setState((state) => {
        return {
          ...state,
          check: true
        }
      })
      check = true
    }

    let pagoRecurrente = generarPagoRecurrente()
    let cuentasBCP = []
    generalDispatch(GeneralActions.updateEstadoCargando(true))
    generalDispatch(GeneralActions.updateError(null))

    for(let i = 0; i < pagoRecurrente.length; i++) {
      let pago = pagoRecurrente[i]
      let contadorPago = cotizacion.contadorPago !== undefined
        ? cotizacion.contadorPago.filter(contador => contador.codMoneda === pago.codMoneda)[0]
        : undefined
      let contador = contadorPago !== undefined ? contadorPago.contador : 1
      let pagoBCPAux = cuentasBCP.filter(pagoBCP => pagoBCP.codMoneda === pago.codMoneda)[0]
      if(pago.codigoTipoCobranza === 1 && pago.codigoOperadorTarjeta === 1 && state.camposModificados.numeroTarjeta[pago.codMoneda] &&
        contador < 2 && pagoBCPAux === undefined) {
          if(check !== true || pago.codMoneda !== Constantes.COD_MONEDA_SOLES) {
            cuentasBCP.push(pago)
          }
      }
    }

    if(cuentasBCP.length > 0) {
      //Invocar validación Cuenta BCP
      let validacionCuentaBCP = true
      let validacionCuenta = null
      for(let pagoBCP of cuentasBCP) {
        validacionCuenta = await validarPagoRecurrente({
          codigoTipoCuenta: pagoBCP.codigoTipoCuenta,
          numeroCuenta: pagoBCP.numeroTarjeta,
          codMoneda: pagoBCP.codMoneda,
          tipoDocumento: cotizacion.contratante.tipoDocumento.codigo,
          numeroDocumento: cotizacion.contratante.numeroDocumento
        }, pagoRecurrente, check)

        validacionCuentaBCP = validacionCuentaBCP && validacionCuenta.valor

        generalDispatch(GeneralActions.addContadorPago(pagoBCP.codMoneda))

        let numeroTarjeta = state.camposModificados.numeroTarjeta
        numeroTarjeta[pagoBCP.codMoneda] = false
        setState((state) => {
          return {
            ...state,
            camposModificados: {
              ...state.camposModificados,
              numeroTarjeta: numeroTarjeta
            }
          }
        })

        if(!validacionCuentaBCP) {
          break;
        }
      }

      return validacionCuenta
    } else {
      //Continuar con el flujo
      let salida = await actualizarPagoRecurrente(pagoRecurrente, check)
      return salida
    }
  }

  const generarPagoRecurrente = () => {
    let nuevo = {}
    let nuevo2 = {}
    let nuevo3 = {}
    let recurrenteAux = []
    let idSolicitudDolar = state.productos.filter(pro => pro.simboloMoneda === '$').map(p => p.idSolicitud)
    let idSolicitudSol = state.productos.filter(pro => pro.simboloMoneda === 'S/').map(p => p.idSolicitud)

    let tarjetaDolares = encriptamiento(state.pago[0].numeroTarjeta && state.pago[0].numeroTarjeta.split('-').join(''))
    let tarjetaSoles = ''

    if (state.cuentaInicial === null) {
      setState((state) => {
        return {
          ...state,
          cuentaInicial: parseInt(state.pago[0].numeroTarjeta && state.pago[0].numeroTarjeta.split('-').join(''))
        }
      })
    }

    if (idSolicitudSol.length > 0 && idSolicitudDolar.length === 0) {
      tarjetaSoles = encriptamiento(state.pago[0].numeroTarjeta && state.pago[0].numeroTarjeta.split('-').join(''))
      if (state.cuentaInicial === null) {
        setState((state) => {
          return {
            ...state,
            cuentaInicial: parseInt(state.pago[0].numeroTarjeta && state.pago[0].numeroTarjeta.split('-').join(''))
          }
        })
      }
    } else {
      tarjetaSoles = encriptamiento(state.pago[1].numeroTarjeta && state.pago[1].numeroTarjeta.split('-').join(''))
    }

    let vencD = encriptamiento(state.pago[0].fechaVencimiento && state.pago[0].fechaVencimiento.split('/').join(''))
    //CMUNAYLLA: validacion para encriptar fecha de vencimiento cuando solo hay productos en soles
    let vencS = ''
    if (idSolicitudSol.length > 0 && idSolicitudDolar.length === 0) {
      vencS = encriptamiento(state.pago[0].fechaVencimiento && state.pago[0].fechaVencimiento.split('/').join(''))
    } else {
      vencS = encriptamiento(state.pago[1].fechaVencimiento && state.pago[1].fechaVencimiento.split('/').join(''))
    }

    //se agregaron validaciones internas para el envio de data en caso sea cobranza directa
    if (idSolicitudDolar.length === 3) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[2],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[2],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudSol.length === 3) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[2],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[2],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudDolar.length === 2 && idSolicitudSol.length === 1 && state.check) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudDolar.length === 2 && idSolicitudSol.length === 1) {
      if (state.pago[0].codigoTipoCobranza === 4 && state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudDolar.length === 1 && idSolicitudSol.length === 2 && state.check) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudDolar.length === 1 && idSolicitudSol.length === 2) {
      if (state.pago[0].codigoTipoCobranza === 4 && state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo3 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
      recurrenteAux.push(nuevo3)
    } else if (idSolicitudDolar.length === 2) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[1],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
    } else if (idSolicitudSol.length === 2) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[1],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
    } else if (idSolicitudDolar.length === 1 && idSolicitudSol.length === 1 && state.check) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
    } else if (idSolicitudDolar.length === 1 && idSolicitudSol.length === 1) {
      if (state.pago[0].codigoTipoCobranza === 4 && state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else if (state.pago[1].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
        nuevo2 = {
          ...state.pago[1],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[1].codigoTipoCuenta === 0 ? 10 : state.pago[1].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
      recurrenteAux.push(nuevo2)
    } else if (idSolicitudDolar.length === 1) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaDolares,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudDolar[0],
          fechaVencimiento: vencD,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_DOLARES
        }
      }
      recurrenteAux.push(nuevo)
    } else if (idSolicitudSol.length === 1) {
      if (state.pago[0].codigoTipoCobranza === 4) {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: '',
          codigoTipoCuenta: null,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: '',
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      } else {
        nuevo = {
          ...state.pago[0],
          numeroTarjeta: tarjetaSoles,
          usuario: user.info.IdUsuario,
          idSolicitud: idSolicitudSol[0],
          fechaVencimiento: vencS,
          codigoTipoCuenta: state.pago[0].codigoTipoCuenta === 0 ? 10 : state.pago[0].codigoTipoCuenta,
          codMoneda: Constantes.COD_MONEDA_SOLES
        }
      }
      recurrenteAux.push(nuevo)
    }

    let ultimoRecurre = state.recurrente === null ? recurrenteAux : state.recurrente
    return ultimoRecurre
  }

  const actualizarPagoRecurrente = async (pagoRecurrente, check) => {
    let pagosRequest = []
    pagoRecurrente.map((pago, index) => {
        if(index !== 1 || !check) {
            pagosRequest.push(pago)
        } else {
            pagosRequest.push({
                ...pagoRecurrente[0],
                idSolicitud: pago.idSolicitud
            })
        }
        return pago
    })

    const response = await PagoRecurrenteRepository.actualizarPagoRecurrente(cotizacion.idSolicitudMultiple, pagosRequest, check)
    if(response.error === null) {
      generalDispatch(GeneralActions.agregarRecurrente(pagosRequest))
      let pasar = []
      let arrays = []
      for (const producto of cotizacion.productos) {

        let objetoScore = await cargarScore(producto, pagosRequest)

        pasar.push(objetoScore.valor)

        if (objetoScore.req !== null)
          arrays = [...arrays.concat(objetoScore.req)]
      }

      let p = null
      if (pasar.some(x => x === true)) {
        p = await registrarScore(arrays)
      } else {
        p = await obtenerRequisitos()
      }

      return p
    } else {
      generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      return false
    }
  }

  /**Llamada servicios semaforo-requisitos */
  const cargarScore = async (producto, recurrente) => {
    let paths = {
        codigoIntermediario: user.info.CodigoIntermediario,
        codigoAgencia: cotizacion.codigoAgencia,
        lineaNegocio: producto.codigoLineaNegocio,
        tipoDocumento: !cotizacion.esDistintoAsegurado ? cotizacion.asegurado.tipoDocumento.descripcion.trim()
          : cotizacion.contratante.tipoDocumento.descripcion.trim(),
        numeroDocumento: !cotizacion.esDistintoAsegurado ? cotizacion.asegurado.numeroDocumento
          : cotizacion.contratante.numeroDocumento
    }

    let params = {
        cantidadBeneficiarios: cotizacion.beneficiarios.length,
        primaTotal: producto.primaTotal,
        fechaNacimiento: !cotizacion.esDistintoAsegurado ? cotizacion.asegurado.fechaNacimiento
          : cotizacion.contratante.fechaNacimiento,
        tieneConyuge: Funciones.saberConyuge(cotizacion.beneficiarios),
        primaTarget: producto.primaTarget,
        frecuenciaPago: producto.frecuenciaPago.codigo,
        tipoCobranza: Funciones.obtenerTipoCobranza(producto, cotizacion.solicitudes, recurrente)
    }

    let headers = {
        userApplication: user.info.CodigoIntermediario,
        idTransaction: prospecto.idProspecto
    }

    const resRequisitoScore = await RequisitoRepository.obtenerRequisitoScore(paths, params, headers)
    if (resRequisitoScore.score !== null && resRequisitoScore.score !== undefined) {
        if (resRequisitoScore.score.length > 0) {
            const nuevoRequisito = resRequisitoScore.score.map(score => {
                let newScore = {
                    idAsegurado: cotizacion.asegurado.idAsegurado,
                    idSolicitud: Funciones.obtenerIdSolicitud(producto, cotizacion.solicitudes),
                    codigoEstadoRequisito: 1,
                    codigoRequisito: score.idRequisito
                }
                return newScore
            })

            return { req: nuevoRequisito, valor: true }
        } else {
            return { req: null, valor: false }
        }
    } else {
        return { req: null, valor: false }
    }
  }

  const registrarScore = async (requisitos) => {
      await RequisitoRepository.registrarRequisitoScore(requisitos)
      let salida = await obtenerRequisitos()
      return salida
  }

  const validarPagoRecurrente = async (pagoRecurrente, updatePago, check) => {
    const response = await PagoRecurrenteRepository.validarPagoRecurrente(pagoRecurrente, cotizacion.idSolicitudMultiple)
    if(response.error === null) {
      if(response.validacion !== null && response.validacion !== '') {
        let moneda = (pagoRecurrente.codMoneda === Constantes.COD_MONEDA_DOLARES ? 'Dolares' : 'Soles')
        setState((state) => {
          return {
            ...state,
            codMonedaError: moneda
          }
        })
        generalDispatch(GeneralActions.updateError({ mensajeRespuesta: response.validacion },
          ('¡Alerta con tu productos en ' + moneda + '!'), false))
        return false
      } else {
        setState((state) => {
          return {
            ...state,
            codMonedaError: null
          }
        })
        return await actualizarPagoRecurrente(updatePago, check)
      }
    } else {
      //generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!'))
      return await actualizarPagoRecurrente(updatePago, check)
    }
  }

  const obtenerRequisitos = async () => {
    const resRequisitos = await RequisitoRepository.obtenerRequisitos(cotizacion.idSolicitudMultiple)
    if (resRequisitos.error === null) {
        generalDispatch(GeneralActions.setRequisitosIniciales(resRequisitos.requisitos))
        let pasar = null

        if (resRequisitos.requisitos.examenes.length > 0) pasar = false 
        else  pasar = true
      
        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })

        let pasarAdicional = true
        if(esAseguradoAdicional){
          const resRequisitosAdicional = await RequisitoRepository.obtenerRequisitosAdicional(cotizacion.idSolicitudMultiple)
          if (resRequisitosAdicional.requisitos.examenes.length > 0) pasarAdicional = false 
          else  pasarAdicional = true
        }

        return {next: pasar && pasarAdicional, valor: true}
    } else {
        generalDispatch(GeneralActions.updateError(resRequisitos.error, '¡Alerta!', true))
        return {next: true, valor: false}
    }
  }

  const validarPantalla = async () => {
    let validado = true

    let visa = /^4[0-9]{12}(?:[0-9]{3})?$/
    let mastercard = /^5[1-5][0-9]{14}$/
    let american = /^3[47][0-9]{13}$/
    let diners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/

    let bcp_ahorros_s = /^[0-9]{11}0[0-9]{2}$/
    let bcp_ahorros_d = /^[0-9]{11}1[0-9]{2}$/
    let bcp_corriente_s = /^[0-9]{10}0[0-9]{2}$/
    let bcp_corriente_d = /^[0-9]{10}1[0-9]{2}$/
    let bcp_maestra_s = /^[0-9]{10}0[0-9]{2}$/
    let bcp_maestra_d = /^[0-9]{10}1[0-9]{2}$/
    let bcp_credimas = /^[0-9]{13}(?:[0-9]{3})?$/
    let cuenta_maestra_bcp = /^[0-9]{13}[01]{1}[0-9]{2}$/

    let continental = /^0[01]{1}11[0-9]{4}[0-9]{10}$/

    let scotia_ahorros_s = /^14[0-9]{10}$/
    let scotia_ahorros_d = /^83[0-9]{10}$/
    let scotia_corriente_s = /^01[0-9]{10}$/
    let scotia_corriente_d = /^07[0-9]{10}$/

    let financiero = /^0000[0-9]{9}/
    let interbank = /^[0-9]{13}/
    let trujillo = /^[0-9]{12}/

    const asignarValidacionCampo = (campo, valor, campo2, mensaje, index) => {
      validado = validado && valor
      let campos = state.campoValidado.map((campoAux, indexCampo) => {
        if (index === indexCampo) {
          if (campo === 'medioPago') {
            campoAux.medioPago = valor
          } else if (campo === 'bancoEntidad') {
            campoAux.bancoEntidad = valor
          } else if (campo === 'tipoCuenta') {
            campoAux.tipoCuenta = valor
          } else if (campo === 'numeroCuenta') {
            campoAux.numeroCuenta = valor
          } else if (campo === 'operadorTarjeta') {
            campoAux.operadorTarjeta = valor
          } else if (campo === 'numeroTarjeta') {
            campoAux.numeroTarjeta = valor
          } else if (campo === 'fechaVencimiento') {
            campoAux.fechaVencimiento = valor
          }
        }
        return campoAux
      })

      let mensajes = state.mensajes.map((mensajeAux, indexMensaje) => {
        if (indexMensaje === index) {
          if (campo2 === 'cobranza') {
            mensajeAux.cobranza = mensaje
          } else if (campo2 === 'tipoBanco') {
            mensajeAux.tipoBanco = mensaje
          } else if (campo2 === 'tipoCuenta') {
            mensajeAux.tipoCuenta = mensaje
          } else if (campo2 === 'numeroCuenta') {
            mensajeAux.numeroCuenta = mensaje
          } else if (campo2 === 'tipoTarjeta') {
            mensajeAux.tipoTarjeta = mensaje
          } else if (campo2 === 'numeroTarjeta') {
            mensajeAux.numeroTarjeta = mensaje
          } else if (campo2 === 'vencimiento') {
            mensajeAux.vencimiento = mensaje
          }
        }
        return mensajeAux
      })

      setState((state) => {
        return {
          ...state,
          campoValidado: campos,
          mensajes: mensajes
        }
      })
    }

    // CASO MARCA CHECK
    if (state.check) {
      /*---------------------------------------------CASO PAGO DOLARES-----------------------------------------*/
      if (state.recurrente) {
        if (state.recurrente && state.recurrente[0].codigoTipoCobranza === 3) {
          asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
        }
      } else {
        if (state.pago[0].codigoTipoCobranza === null || state.pago[0].codigoTipoCobranza === 3) {
          asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
        }
      }
      if (state.pago[0].codigoTipoCobranza === 1) {
        if (state.pago[0].codigoOperadorTarjeta === 0 || state.pago[0].codigoOperadorTarjeta === undefined) {
          asignarValidacionCampo('bancoEntidad', false, 'tipoBanco', Constantes.MENSAJE_TIPO_ENTIDAD, 0)
        } else {
          asignarValidacionCampo('bancoEntidad', true, 'tipoBanco', '', 0)
        }

        if (state.pago[0].codigoTipoCuenta === 0 || state.pago[0].codigoTipoCuenta === undefined) {
          asignarValidacionCampo('tipoCuenta', false, 'tipoCuenta', Constantes.MENSAJE_TIPO_CUENTA, 0)
        } else {
          asignarValidacionCampo('tipoCuenta', true, 'tipoCuenta', '', 0)
        }

        if (!state.pago[0].numeroTarjeta) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 1
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_s)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 2
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_d)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 3
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_s)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 4
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_d)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 5
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_s)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 6
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_d)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 9
          && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_credimas)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 10
          && !state.pago[0].numeroTarjeta.split('-').join('').match(cuenta_maestra_bcp)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else if (state.pago[0].codigoOperadorTarjeta === 2 && (state.pago[0].codigoTipoCuenta === 1 ||
          state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
          && !state.pago[0].numeroTarjeta.split('-').join('').match(continental)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 1
          && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_s)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 2
          && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_d)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 3
          && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_s)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 4
          && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_d)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else if (state.pago[0].codigoOperadorTarjeta === 21 && state.pago[0].codigoTipoCuenta === 1
          && !state.pago[0].numeroTarjeta.split('-').join('').match(financiero)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else if (state.pago[0].codigoOperadorTarjeta === 23 && (state.pago[0].codigoTipoCuenta === 1 ||
          state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
          && !state.pago[0].numeroTarjeta.split('-').join('').match(interbank)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else if (state.pago[0].codigoOperadorTarjeta === 37 && state.pago[0].codigoTipoCuenta === 1
          && !state.pago[0].numeroTarjeta.split('-').join('').match(trujillo)) {
          asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
        }
        else {
          asignarValidacionCampo('numeroCuenta', true, 'numeroCuenta', '', 0)
        }
      }
      else if (state.pago[0].codigoTipoCobranza === 2) {
        if (state.pago[0].codigoOperadorTarjeta === 0) {
          asignarValidacionCampo('operadorTarjeta', false, 'tipoTarjeta', Constantes.MENSAJE_TIPO_TARJETA, 0)
        } else {
          asignarValidacionCampo('operadorTarjeta', true, 'tipoTarjeta', '', 0)
        }

        if (!state.pago[0].numeroTarjeta) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 101 && !state.pago[0].numeroTarjeta.split('-').join('')
          .match(visa)) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 102 && !state.pago[0].numeroTarjeta.split('-').join('')
          .match(mastercard)) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 103 && !state.pago[0].numeroTarjeta.split('-').join('')
          .match(american)) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 104 && !state.pago[0].numeroTarjeta.split('-').join('')
          .match(diners)) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
        } else if (state.pago[0].codigoOperadorTarjeta === 107 && !state.pago[0].numeroTarjeta.split('-').join('')
          .match(visa)) {
          asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
        } else {
          asignarValidacionCampo('numeroTarjeta', true, 'numeroTarjeta', '', 0)
        }

        if ((state.pago[0].fechaVencimiento === null || state.pago[0].fechaVencimiento === '')) {
          asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
        } else if (Funciones.esTarjetaVencida(state.pago[0].fechaVencimiento)) {
          asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_FECHA_VENCIDA, 0)
        } else {
          asignarValidacionCampo('fechaVencimiento', true, 'vencimiento', '', 0)
        }
      } /*else {
        asignarValidacionCampo('medioPago', true, 'cobranza', '', 0)
      }*/
    } else {
      /*---------------------------------------------CASO PAGO DOLARES-----------------------------------------*/
      let dolar = cotizacion.productos.filter(s => s.moneda.codigo === 1)
      if (dolar.length > 0) {
        if (state.recurrente) {
          if (state.recurrente && state.recurrente[0].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
          }
        } else {
          if (state.pago[0].codigoTipoCobranza === null || state.pago[0].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
          }
        }
        if (state.pago[0].codigoTipoCobranza === 1) {
          if (state.pago[0].codigoOperadorTarjeta === 0 || state.pago[0].codigoOperadorTarjeta === undefined) {
            asignarValidacionCampo('bancoEntidad', false, 'tipoBanco', Constantes.MENSAJE_TIPO_ENTIDAD, 0)
          } else {
            asignarValidacionCampo('bancoEntidad', true, 'tipoBanco', '', 0)
          }

          if (state.pago[0].codigoTipoCuenta === 0 || state.pago[0].codigoTipoCuenta === undefined) {
            asignarValidacionCampo('tipoCuenta', false, 'tipoCuenta', Constantes.MENSAJE_TIPO_CUENTA, 0)
          } else {
            asignarValidacionCampo('tipoCuenta', true, 'tipoCuenta', '', 0)
          }

          if (!state.pago[0].numeroTarjeta) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 2
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 3
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 4
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 5
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 6
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 9
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_credimas)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 10
            && !state.pago[0].numeroTarjeta.split('-').join('').match(cuenta_maestra_bcp)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 2 && (state.pago[0].codigoTipoCuenta === 1 ||
            state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
            && !state.pago[0].numeroTarjeta.split('-').join('').match(continental)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 2
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 3
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 4
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 21 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(financiero)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 23 && (state.pago[0].codigoTipoCuenta === 1 ||
            state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
            && !state.pago[0].numeroTarjeta.split('-').join('').match(interbank)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 37 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(trujillo)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else {
            asignarValidacionCampo('numeroCuenta', true, 'numeroCuenta', '', 0)
          }
        }
        else if (state.pago[0].codigoTipoCobranza === 2) {
          if (state.pago[0].codigoOperadorTarjeta === 0) {
            asignarValidacionCampo('operadorTarjeta', false, 'tipoTarjeta', Constantes.MENSAJE_TIPO_TARJETA, 0)
          } else {
            asignarValidacionCampo('operadorTarjeta', true, 'tipoTarjeta', '', 0)
          }

          if (!state.pago[0].numeroTarjeta) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 101 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 102 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(mastercard)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 103 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(american)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 104 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(diners)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 107 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else {
            asignarValidacionCampo('numeroTarjeta', true, 'numeroTarjeta', '', 0)
          }

          if ((state.pago[0].fechaVencimiento === null || state.pago[0].fechaVencimiento === '')) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (Funciones.esTarjetaVencida(state.pago[0].fechaVencimiento)) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_FECHA_VENCIDA, 0)
          } else {
            asignarValidacionCampo('fechaVencimiento', true, 'vencimiento', '', 0)
          }
        } /*else {
          asignarValidacionCampo('medioPago', true, 'cobranza', '', 0)
        }*/
      }

      /**---------------------------------------------CASO PAGO SOLES-----------------------------------------*/
      let sol = cotizacion.productos.filter(s => s.moneda.codigo === 2)
      if (sol.length > 0 && dolar.length > 0) {
        if (state.recurrente) {
          if (state.recurrente && state.recurrente[1].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 1)
          }
        } else {
          if (state.pago[1].codigoTipoCobranza === null || state.pago[1].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 1)
          }
        }
        if (state.pago[1].codigoTipoCobranza === 1) {
          if (state.pago[1].codigoOperadorTarjeta === 0 || state.pago[1].codigoOperadorTarjeta === undefined) {
            asignarValidacionCampo('bancoEntidad', false, 'tipoBanco', Constantes.MENSAJE_TIPO_ENTIDAD, 1)
          } else {
            asignarValidacionCampo('bancoEntidad', true, 'tipoBanco', '', 1)
          }

          if (state.pago[1].codigoTipoCuenta === 0 || state.pago[1].codigoTipoCuenta === undefined) {
            asignarValidacionCampo('tipoCuenta', false, 'tipoCuenta', Constantes.MENSAJE_TIPO_CUENTA, 1)
          } else {
            asignarValidacionCampo('tipoCuenta', true, 'tipoCuenta', '', 1)
          }

          if (!state.pago[1].numeroTarjeta) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 1
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 2
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 3
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 4
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 5
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_maestra_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 6
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_maestra_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 9
            && !state.pago[1].numeroTarjeta.split('-').join('').match(bcp_credimas)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 1 && state.pago[1].codigoTipoCuenta === 10
            && !state.pago[1].numeroTarjeta.split('-').join('').match(cuenta_maestra_bcp)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else if (state.pago[1].codigoOperadorTarjeta === 2 && (state.pago[1].codigoTipoCuenta === 1 ||
            state.pago[1].codigoTipoCuenta === 2 || state.pago[1].codigoTipoCuenta === 3 || state.pago[1].codigoTipoCuenta === 4)
            && !state.pago[1].numeroTarjeta.split('-').join('').match(continental)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else if (state.pago[1].codigoOperadorTarjeta === 4 && state.pago[1].codigoTipoCuenta === 1
            && !state.pago[1].numeroTarjeta.split('-').join('').match(scotia_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 4 && state.pago[1].codigoTipoCuenta === 2
            && !state.pago[1].numeroTarjeta.split('-').join('').match(scotia_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 4 && state.pago[1].codigoTipoCuenta === 3
            && !state.pago[1].numeroTarjeta.split('-').join('').match(scotia_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 4 && state.pago[1].codigoTipoCuenta === 4
            && !state.pago[1].numeroTarjeta.split('-').join('').match(scotia_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else if (state.pago[1].codigoOperadorTarjeta === 21 && state.pago[1].codigoTipoCuenta === 1
            && !state.pago[1].numeroTarjeta.split('-').join('').match(financiero)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else if (state.pago[1].codigoOperadorTarjeta === 23 && (state.pago[1].codigoTipoCuenta === 1 ||
            state.pago[1].codigoTipoCuenta === 2 || state.pago[1].codigoTipoCuenta === 3 || state.pago[1].codigoTipoCuenta === 4)
            && !state.pago[1].numeroTarjeta.split('-').join('').match(interbank)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else if (state.pago[1].codigoOperadorTarjeta === 37 && state.pago[1].codigoTipoCuenta === 1
            && !state.pago[1].numeroTarjeta.split('-').join('').match(trujillo)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 1)
          }
          else {
            asignarValidacionCampo('numeroCuenta', true, 'numeroCuenta', '', 1)
          }
        }
        else if (state.pago[1].codigoTipoCobranza === 2) {
          if (state.pago[1].codigoOperadorTarjeta === 0) {
            asignarValidacionCampo('operadorTarjeta', false, 'tipoTarjeta', Constantes.MENSAJE_TIPO_TARJETA, 1)
          } else {
            asignarValidacionCampo('operadorTarjeta', true, 'tipoTarjeta', '', 1)
          }

          if (!state.pago[1].numeroTarjeta) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 101 && !state.pago[1].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 102 && !state.pago[1].numeroTarjeta.split('-').join('')
            .match(mastercard)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 103 && !state.pago[1].numeroTarjeta.split('-').join('')
            .match(american)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 104 && !state.pago[1].numeroTarjeta.split('-').join('')
            .match(diners)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 1)
          } else if (state.pago[1].codigoOperadorTarjeta === 107 && !state.pago[1].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 1)
          } else {
            asignarValidacionCampo('numeroTarjeta', true, 'numeroTarjeta', '', 1)
          }

          if ((state.pago[1].fechaVencimiento === null || state.pago[1].fechaVencimiento === '')) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 1)
          } else if (Funciones.esTarjetaVencida(state.pago[1].fechaVencimiento)) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_FECHA_VENCIDA, 1)
          } else {
            asignarValidacionCampo('fechaVencimiento', true, 'vencimiento', '', 1)
          }
        } /*else {
          asignarValidacionCampo('medioPago', true, 'cobranza', '', 1)
        }*/
      } else if (sol.length > 0 && dolar.length === 0) {
        if (state.recurrente) {
          if (state.recurrente && state.recurrente[0].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
          }
        } else {
          if (state.pago[0].codigoTipoCobranza === null || state.pago[0].codigoTipoCobranza === 3) {
            asignarValidacionCampo('medioPago', false, 'cobranza', Constantes.MENSAJE_MEDIO_PAGO, 0)
          }
        }
        if (state.pago[0].codigoTipoCobranza === 1) {
          if (state.pago[0].codigoOperadorTarjeta === 0 || state.pago[0].codigoOperadorTarjeta === undefined) {
            asignarValidacionCampo('bancoEntidad', false, 'tipoBanco', Constantes.MENSAJE_TIPO_ENTIDAD, 0)
          } else {
            asignarValidacionCampo('bancoEntidad', true, 'tipoBanco', '', 0)
          }

          if (state.pago[0].codigoTipoCuenta === 0 || state.pago[0].codigoTipoCuenta === undefined) {
            asignarValidacionCampo('tipoCuenta', false, 'tipoCuenta', Constantes.MENSAJE_TIPO_CUENTA, 0)
          } else {
            asignarValidacionCampo('tipoCuenta', true, 'tipoCuenta', '', 0)
          }

          if (!state.pago[0].numeroTarjeta) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 2
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 3
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 4
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 5
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 6
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_maestra_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 9
            && !state.pago[0].numeroTarjeta.split('-').join('').match(bcp_credimas)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 1 && state.pago[0].codigoTipoCuenta === 10
            && !state.pago[0].numeroTarjeta.split('-').join('').match(cuenta_maestra_bcp)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 2 && (state.pago[0].codigoTipoCuenta === 1 ||
            state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
            && !state.pago[0].numeroTarjeta.split('-').join('').match(continental)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 2
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_ahorros_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 3
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_s)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 4 && state.pago[0].codigoTipoCuenta === 4
            && !state.pago[0].numeroTarjeta.split('-').join('').match(scotia_corriente_d)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 21 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(financiero)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 23 && (state.pago[0].codigoTipoCuenta === 1 ||
            state.pago[0].codigoTipoCuenta === 2 || state.pago[0].codigoTipoCuenta === 3 || state.pago[0].codigoTipoCuenta === 4)
            && !state.pago[0].numeroTarjeta.split('-').join('').match(interbank)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else if (state.pago[0].codigoOperadorTarjeta === 37 && state.pago[0].codigoTipoCuenta === 1
            && !state.pago[0].numeroTarjeta.split('-').join('').match(trujillo)) {
            asignarValidacionCampo('numeroCuenta', false, 'numeroCuenta', Constantes.MENSAJE_CUENTA_VALIDO, 0)
          }
          else {
            asignarValidacionCampo('numeroCuenta', true, 'numeroCuenta', '', 0)
          }
        }
        else if (state.pago[0].codigoTipoCobranza === 2) {
          if (state.pago[0].codigoOperadorTarjeta === 0) {
            asignarValidacionCampo('operadorTarjeta', false, 'tipoTarjeta', Constantes.MENSAJE_TIPO_TARJETA, 0)
          } else {
            asignarValidacionCampo('operadorTarjeta', true, 'tipoTarjeta', '', 0)
          }

          if (!state.pago[0].numeroTarjeta) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 101 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 102 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(mastercard)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 103 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(american)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 104 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(diners)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else if (state.pago[0].codigoOperadorTarjeta === 107 && !state.pago[0].numeroTarjeta.split('-').join('')
            .match(visa)) {
            asignarValidacionCampo('numeroTarjeta', false, 'numeroTarjeta', Constantes.MENSAJE_TARJETA_VALIDA, 0)
          } else {
            asignarValidacionCampo('numeroTarjeta', true, 'numeroTarjeta', '', 0)
          }

          if ((state.pago[0].fechaVencimiento === null || state.pago[0].fechaVencimiento === '')) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_CAMPO_OBLIGATORIO, 0)
          } else if (Funciones.esTarjetaVencida(state.pago[0].fechaVencimiento)) {
            asignarValidacionCampo('fechaVencimiento', false, 'vencimiento', Constantes.MENSAJE_FECHA_VENCIDA, 0)
          } else {
            asignarValidacionCampo('fechaVencimiento', true, 'vencimiento', '', 0)
          }
        } /*else {
          asignarValidacionCampo('medioPago', true, 'cobranza', '', 1)
        }*/
      }
    }

    if (validado) {
      if (state.recurrente) {
        let salidaReq = await obtenerRequisitos()
        return salidaReq
      } else {
        let salida = await validarDatosIguales()
        return salida
      }
    } else {
      return false
    }
  }

  const handleCambiaCheck = () => {
    setState((state) => {
      return {
        ...state,
        check: !state.check
      }
    })
  }

  const borrarGet = () => {
    setBloqueaData(false)
    setState((state) => {
      return {
        ...state,
        recurrente: null,
        check: false
      }
    })
  }
  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true && complete !== undefined) {
      return true
    } else {
      return false
    }
  }

  const [mover, setMover] = useState(false)
  const mueveContenido = (valor) => {
    setMover(valor)
  }

  return (
    <React.Fragment>
      <Header history={history} valor={cotizacion.requisitosIniciales !== undefined
        && cotizacion.requisitosIniciales} />
      <SubMenu history={history} modal={state.estaCargando} desplaza={mueveContenido} />
      <section className={styles['areadatosusuario']}
        style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}}
      >
        <div className={styles['areadatosprospecto']}>
          <div style={{ display: "flex" }}>
            <Subtitle
              sname='Elige como harás tus pagos recurrentes'
              smostrar='false'
            />
            {state.recurrente !== null ?
              <button
                className={Deshabilitar() !== true ? `${styles['btn-pago-accion']} ${styles['w3-margen']}`
                  : `${styles['btn-pago-accion-inhabilitar']} ${styles['w3-margen']}`}
                onClick={Deshabilitar() !== true ? borrarGet : null}
                style={mover ? { marginLeft: '52%' } : {}}
              >
                Limpiar datos
              </button>
              : null}
          </div>

          {state.productosMostrar !== null ? state.productosMostrar.map((producto, index) => {
            return (
              <React.Fragment key={index}>
                {index === 1
                  ? <div className={styles['areaseleccion']}>
                    <input
                      type='checkbox'
                      className={styles.check_box}
                      onChange={handleCambiaCheck}
                      checked={state.check}
                      disabled={Deshabilitar() !== true ? false : true}
                    />
                    <span>
                      Deseo que todos mis productos sean cobrados con el mismo medio de
                      pago.
                    </span>
                  </div>
                  : null
                }

                <PagoCard
                  state={state}
                  setState={setState}
                  pago={state.pago && state.pago[index]}
                  producto={producto}
                  index={index}
                  bloqueo={index === 1 ? state.check : false}
                  dataBloqueada={bloqueaData}
                />

              </React.Fragment>
            )
          })
            : null}
        </div>
        <Footer
          history={history}
          validarPantalla={validarPantalla}
          saltaProximaOpcion={Deshabilitar() ? !cotizacion.requisitosIniciales : true}
        />
      </section>
    </React.Fragment>
  )
}
export default PagoRecurrente